module.exports = __webpack_public_path__ + "img/cards.998bd728.png";